module.exports = __webpack_public_path__ + "img/user.5d97660a.jpeg";